import React, { useState } from 'react';

// Google Fonts'tan Poppins bağlantısı
const fontLink = document.createElement('link');
fontLink.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400&display=swap';
fontLink.rel = 'stylesheet';
document.head.appendChild(fontLink);

const YAPAY_SOHBETLER = [
  { id: 1, numara: "+90 535 955 11 02", sonMesaj: "160 TL kargo ücreti hocam", zaman: "Dün", asama: "TAMAMLANDI", botAktif: true, mesajlar: [{ kim: "m", metin: "160 TL kargo ücreti hocam" }] },
  { id: 2, numara: "+90 535 380 42 08", sonMesaj: "Merhaba, mesajınız için teşekkürler.", zaman: "Dün", asama: "OTOMATIK", botAktif: true, mesajlar: [{ kim: "m", metin: "Merhaba fiyat alabilir miyim?" }, { kim: "b", metin: "Merhaba! Menüden seçim yapın." }] },
  { id: 3, numara: "+90 506 852 49 17", sonMesaj: "Ödeme gelmiş miydi?", zaman: "Dün", asama: "SIPARISLER", botAktif: false, mesajlar: [{ kim: "m", metin: "Ödeme gelmiş miydi?" }] },
  { id: 4, numara: "+90 544 641 97 40", sonMesaj: "Ben sadece bunun üstündeki reklam olmadan...", zaman: "Cmt", asama: "EKSIK_HATA", botAktif: false, 
    mesajlar: [
      { kim: "b", metin: "Örnek Davetiyeniz Hoşgeldiniz..." },
      { kim: "m", metin: "Merhaba görseldeki gibi istiyorum." },
      { kim: "m", metin: "Ben sadece bunun üstündeki reklam olmadan tek bir tane istiyorum.", resim: "https://via.placeholder.com/150" }
    ] 
  }
];

export default function Whatsapp() {
  const [seciliAltAsama, setSeciliAltAsama] = useState('TÜMÜ');
  const [seciliSohbet, setSeciliSohbet] = useState(YAPAY_SOHBETLER[0]);
  const [sohbetler, setSohbetler] = useState(YAPAY_SOHBETLER);

  const toggleBot = (id, e) => {
    e.stopPropagation();
    setSohbetler(prev => prev.map(s => s.id === id ? { ...s, botAktif: !s.botAktif } : s));
    if (seciliSohbet.id === id) {
      setSeciliSohbet(prev => ({ ...prev, botAktif: !prev.botAktif }));
    }
  };

  const filtrelenmişSohbetler = sohbetler.filter(s => {
    if (seciliAltAsama === 'TÜMÜ') return true;
    return s.asama === seciliAltAsama;
  });

  // İstediğin Defter-1 buton özelliklerine sadık kalınarak genişletilmiş ve eşitlenmiş stil
  const btnStyle = (aktifDurum) => ({
    flex: 1, // Tüm butonların genişliğini eşit yapar
    padding: '8px 12px', // Yukarı aşağı yönde genişletildi
    cursor: 'pointer',
    background: seciliAltAsama === aktifDurum ? '#3884C2' : 'white',
    color: seciliAltAsama === aktifDurum ? 'white' : 'black',
    border: '1px solid #ccc',
    borderRadius: '5px',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '12px',
    fontWeight: seciliAltAsama === aktifDurum ? '600' : '400',
    transition: 'all 0.15s ease',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: '1.2'
  });

  return (
    // Üst boşluk düzeltildi (marginTop sıfırlandı, padding eklendi), butonlar aşağı kaydırıldı
    <div style={{ fontFamily: "'Poppins', sans-serif", background: '#f8fafc', padding: '15px 20px 0 20px', marginLeft: '-20px', marginRight: '-20px' }}>
      
      {/* BUTON ARALARI EŞİT (gap: 10px) VE TÜM BLOKLAR EŞİT GENİŞLİKTE */}
      <div style={{ display: 'flex', background: 'white', padding: '15px 12px', border: '1px solid #ccc', borderRadius: '5px', gap: '10px', alignItems: 'center', justifyContent: 'space-between', marginBottom: '15px' }}>
        
        {/* Tümü Butonu */}
        <button onClick={() => setSeciliAltAsama('TÜMÜ')} style={btnStyle('TÜMÜ')}>
          Tümü ({sohbetler.length})
        </button>

        {/* Kategori Bloğu 1 */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <button onClick={() => setSeciliAltAsama('TAMAMLANDI')} style={btnStyle('TAMAMLANDI')}>Tamamlandı</button>
          <button onClick={() => setSeciliAltAsama('DEVAM_EDIYOR')} style={btnStyle('DEVAM_EDIYOR')}>Devam Ediyor</button>
        </div>

        {/* Kategori Bloğu 2 */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <button onClick={() => setSeciliAltAsama('OTOMATIK')} style={btnStyle('OTOMATIK')}>Otomatik</button>
          <button onClick={() => setSeciliAltAsama('AKTARILAN')} style={btnStyle('AKTARILAN')}>Aktarılan</button>
        </div>

        {/* Kategori Bloğu 3 */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <button onClick={() => setSeciliAltAsama('SIPARISLER')} style={btnStyle('SIPARISLER')}>Siparişler</button>
          <button onClick={() => setSeciliAltAsama('BILGI_TALEPLERI')} style={btnStyle('BILGI_TALEPLERI')}>Bilgi Talepleri</button>
        </div>

        {/* Kategori Bloğu 4 */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <button onClick={() => setSeciliAltAsama('SON_DURUM')} style={btnStyle('SON_DURUM')}>Son Durum</button>
          <button onClick={() => setSeciliAltAsama('EK_TALEPLERI')} style={btnStyle('EK_TALEPLERI')}>Ek Talepleri</button>
        </div>

        {/* Kategori Bloğu 5 */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <button onClick={() => setSeciliAltAsama('EKSIK_HATA')} style={btnStyle('EKSIK_HATA')}>Eksik / Hata</button>
          <button onClick={() => setSeciliAltAsama('TESEKKUR')} style={btnStyle('TESEKKUR')}>Teşekkür</button>
        </div>

        {/* Diğer Butonu */}
        <button onClick={() => setSeciliAltAsama('DIGER')} style={btnStyle('DIGER')}>
          Diğer
        </button>

      </div>

      {/* ALT ALAN DİKEY GENİŞLİĞİ KORUNDU */}
      <div style={{ display: 'flex', height: 'calc(100vh - 210px)' }}>
        
        {/* COMPACT SOL SOHBET LİSTESİ */}
        <div style={{ width: '320px', background: 'white', borderRight: '1px solid #e2e8f0', overflowY: 'auto' }}>
          {filtrelenmişSohbetler.map(chat => (
            <div key={chat.id} onClick={() => setSeciliSohbet(chat)} style={{ padding: '8px 12px', borderBottom: '1px solid #f1f5f9', cursor: 'pointer', background: seciliSohbet.id === chat.id ? '#f0f4f8' : 'white', transition: 'background 0.2s' }}>
              
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <strong style={{ fontSize: '12px', color: '#1e293b' }}>{chat.numara}</strong>
                  <span style={{ fontSize: '9px', background: '#e2e8f0', color: '#475569', padding: '1px 5px', borderRadius: '3px', fontWeight: '500' }}>
                    {chat.asama.substring(0, 5)}
                  </span>
                </div>
                
                <div onClick={(e) => toggleBot(chat.id, e)} style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer', background: chat.botAktif ? '#f0fdf4' : '#fef2f2', border: `1px solid ${chat.botAktif ? '#bbf7d0' : '#fecaca'}`, padding: '2px 6px', borderRadius: '4px' }}>
                  <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: chat.botAktif ? '#22c55e' : '#ef4444' }}></span>
                  <span style={{ fontSize: '9px', color: chat.botAktif ? '#166534' : '#991b1b', fontWeight: '500' }}>
                    {chat.botAktif ? 'BOT' : 'EL'}
                  </span>
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ fontSize: '11px', color: '#64748b', width: '230px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {chat.sonMesaj}
                </div>
                <span style={{ fontSize: '10px', color: '#94a3b8' }}>{chat.zaman}</span>
              </div>

            </div>
          ))}
        </div>

        {/* SAĞ YAZIŞMA ALANI */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: '#efeae2' }}>
          <div style={{ padding: '12px 15px', background: '#f0f2f5', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <strong style={{ fontSize: '13px' }}>{seciliSohbet?.numara}</strong>
              <div style={{ fontSize: '11px', color: '#64748b' }}>Mevcut Aşama: {seciliSohbet?.asama}</div>
            </div>
            <div style={{ fontSize: '12px', fontWeight: '600', color: seciliSohbet?.botAktif ? '#22c55e' : '#ef4444', background: seciliSohbet?.botAktif ? '#e6f4ea' : '#fce8e6', padding: '4px 10px', borderRadius: '4px' }}>
              {seciliSohbet?.botAktif ? 'OTOMASYON AKTİF' : 'TEMSİLCİ MODU (BOT KAPALI)'}
            </div>
          </div>

          <div style={{ flex: 1, padding: '20px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {seciliSohbet?.mesajlar.map((m, i) => (
              <div key={i} style={{ alignSelf: m.kim === 'm' ? 'flex-start' : 'flex-end', background: m.kim === 'm' ? 'white' : '#d9fdd3', padding: '8px 12px', borderRadius: '8px', maxWidth: '60%', boxShadow: '0 1px 1px rgba(0,0,0,0.05)', fontSize: '12px', lineHeight: '1.4' }}>
                {m.metin}
                {m.resim && (
                  <div style={{ marginTop: '5px' }}>
                    <img src={m.resim} alt="Müşteri Görseli" style={{ maxWidth: '100%', borderRadius: '4px', cursor: 'pointer' }} onClick={() => alert('Görsel orijinal boyutta açıldı.')} />
                    <button style={{ display: 'block', marginTop: '5px', width: '100%', padding: '4px', background: '#3884C2', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '10px', fontWeight: '500' }}>Görseli Bilgisayara İndir</button>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div style={{ padding: '10px 15px', background: '#f0f2f5', display: 'flex' }}>
            <input type="text" placeholder="Müşteriye mesaj yazın..." style={{ flex: 1, padding: '8px 15px', borderRadius: '20px', border: 'none', fontSize: '12px', fontFamily: "'Poppins', sans-serif" }} />
          </div>
        </div>

      </div>
    </div>
  );
}